/* Internal Vars */
// import BookingPeriodsJar from "./jar";

import bpStatusTranslate from "./translation/bp-status-dk";

/* Services */
import BookingPeriodsService from "./service";

/* Storage */
// import BasketStorage from "./storage";

/* Factories */

import BookingPeriodsEntriesFactory from "./entries/";

// /* Facades */
import BookingPeriods from "./facade";

const modul = angular
    .module("BookingPeriodsModule", [])

    /**
     * Const
     */

    .filter("translateBpStatus", bpStatusTranslate)
    /**
     * BookingPeriodsJar - Holds variables internally
     */
    // .service("BookingPeriodsJar", BookingPeriodsJar)

    /**
     * Services
     * * can only have utility dependencies
     */
    .service("BookingPeriodsService", BookingPeriodsService)

    /**
     * Storage
     * can only have utility and services as dependencies
     */
    // .factory("BasketStorage", BasketStorage)

    /**
     * Factories
     */
    // .factory("BookingPeriodsFactory", BookingPeriodsFactory)
    .factory("BookingPeriodsEntriesFactory", BookingPeriodsEntriesFactory)

    /**
     * Facades
     */
    .factory("BookingPeriods", BookingPeriods);

export default modul.name;
